import type React from "react";

import {
  Tooltip as ShadcnTooltip,
  TooltipContent as ShadcnTooltipContent,
  TooltipProvider as ShadcnTooltipProvider,
  TooltipTrigger as ShadcnTooltipTrigger,
} from "src/shadcn/components/tooltip";

const Tooltip = (props: React.ComponentProps<typeof ShadcnTooltip>) => (
  <ShadcnTooltip {...props} />
);

const TooltipContent = (
  props: React.ComponentProps<typeof ShadcnTooltipContent>
) => <ShadcnTooltipContent {...props} />;

const TooltipProvider = (
  props: React.ComponentProps<typeof ShadcnTooltipProvider>
) => <ShadcnTooltipProvider {...props} />;

const TooltipTrigger = (
  props: React.ComponentProps<typeof ShadcnTooltipTrigger>
) => <ShadcnTooltipTrigger {...props} />;

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger };
